var $2ca7ea366384817b$exports = {};
$2ca7ea366384817b$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " a ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " seleccionado");
  },
  "finishRangeSelectionPrompt": "Haga clic para terminar de seleccionar rango de fechas",
  "maximumDate": "\xDAltima fecha disponible",
  "minimumDate": "Primera fecha disponible",
  "next": "Siguiente",
  "previous": "Anterior",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Fecha seleccionada: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Intervalo seleccionado: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Haga clic para comenzar a seleccionar un rango de fechas",
  "todayDate": function todayDate(args) {
    return "Hoy, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Hoy, ".concat(args.date, " seleccionado");
  }
};
export { $2ca7ea366384817b$exports as default };